(function () {
  'use strict';

  if (window.PrewornSearchAnalyticsLoaded) return;
  window.PrewornSearchAnalyticsLoaded = true;

  var API_URL = 'https://preworn.co.uk/sandbox/shopify-catalog-index/preworn_search_analytics_api.php';
  var PENDING_KEY = 'preworn:search-analytics:pending-v1';
  var HISTORY_KEY = 'prewornSearchAnalytics';
  var PROFILE_KEY = 'preworn:shopping-profile:v1';
  var SESSION_PROFILE_KEY = 'preworn:shopping-profile-session:v1';
  var SESSION_KEY = 'preworn:shopping-session:v1';
  var ACCOUNT_LINK_KEY = 'preworn:shopping-profile-linked:v1';
  var ACCOUNT_PROFILE_URL = '/apps/preworn/wardrobes/search-profile';
  var PENDING_MAX_AGE = 10 * 60 * 1000;
  var queued = {};
  var sending = {};

  function automatedClient() {
    var userAgent = window.navigator && window.navigator.userAgent
      ? window.navigator.userAgent : '';
    return /bot(?:\/|\b)|crawler|spider|slurp|bingpreview|facebookexternalhit|meta-externalagent|tiktokspider|bytespider|applebot|amazonbot|semrush|ahrefs|mj12bot|petalbot|yandexbot|duckduckbot|baiduspider|gptbot|chatgpt-user|claudebot|perplexitybot/i.test(userAgent);
  }

  function analyticsAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function preferencesAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint8Array(16);
      window.crypto.getRandomValues(values);
      values[6] = (values[6] & 15) | 64;
      values[8] = (values[8] & 63) | 128;
      var hex = Array.prototype.map.call(values, function (value) {
        return value.toString(16).padStart(2, '0');
      }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' +
        hex.slice(16, 20) + '-' + hex.slice(20);
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var value = Math.floor(Math.random() * 16);
      return (character === 'x' ? value : (value & 3) | 8).toString(16);
    });
  }

  function storedId(storage, key) {
    try {
      var value = String(storage.getItem(key) || '').toLowerCase();
      return /^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(value)
        ? value : '';
    } catch (error) {
      return '';
    }
  }

  function ensureStoredId(storage, key) {
    var value = storedId(storage, key);
    if (value) return value;
    value = randomId();
    try { storage.setItem(key, value); } catch (error) {}
    return value;
  }

  function profileOwner() {
    if (!loggedInCustomer()) return 'guest';
    var customerId = window.PREWORN_CUSTOMER && window.PREWORN_CUSTOMER.id;
    return customerId ? 'account:' + String(customerId) : 'guest';
  }

  function persistentProfileId() {
    var owner = profileOwner();
    var record = null;
    try {
      var raw = window.localStorage.getItem(PROFILE_KEY);
      if (/^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(String(raw || ''))) {
        record = { id: String(raw).toLowerCase(), owner: 'guest' };
      } else if (raw) {
        record = JSON.parse(raw);
      }
    } catch (error) {}
    var validId = record && /^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(String(record.id || '').toLowerCase());
    var canAdoptGuest = validId && record.owner === 'guest' && owner !== 'guest';
    if (!validId || (record.owner !== owner && !canAdoptGuest)) {
      record = { id: randomId(), owner: owner };
    } else {
      record.id = String(record.id).toLowerCase();
      record.owner = owner;
    }
    try { window.localStorage.setItem(PROFILE_KEY, JSON.stringify(record)); } catch (error) {}
    return record.id;
  }

  function searchIdentity() {
    if (!analyticsAllowed()) return null;
    var persistent = preferencesAllowed();
    var profileId = persistent
      ? persistentProfileId()
      : ensureStoredId(window.sessionStorage, SESSION_PROFILE_KEY);
    var sessionId = ensureStoredId(window.sessionStorage, SESSION_KEY);
    if (!profileId || !sessionId) return null;
    return {
      profileId: profileId,
      sessionId: sessionId,
      profilePersistent: persistent,
      analyticsAllowed: true,
      preferencesAllowed: persistent
    };
  }

  function loggedInCustomer() {
    return !!(window.PREWORN_CUSTOMER && window.PREWORN_CUSTOMER.loggedIn);
  }

  function linkAccountProfile(identity) {
    if (!identity || !identity.profilePersistent || !loggedInCustomer()) return;
    try {
      if (window.sessionStorage.getItem(ACCOUNT_LINK_KEY) === identity.profileId) return;
    } catch (error) {}
    window.fetch(ACCOUNT_PROFILE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        profileId: identity.profileId,
        analyticsAllowed: true,
        preferencesAllowed: true
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Search profile link failed');
      try { window.sessionStorage.setItem(ACCOUNT_LINK_KEY, identity.profileId); } catch (error) {}
    }).catch(function () {});
  }

  function removeIdentityFields(payload) {
    ['profileId', 'sessionId', 'profilePersistent',
      'analyticsAllowed', 'preferencesAllowed'].forEach(function (key) {
      delete payload[key];
    });
  }

  function attachCurrentIdentity(payload) {
    removeIdentityFields(payload);
    var identity = searchIdentity();
    if (!identity) return payload;
    Object.keys(identity).forEach(function (key) { payload[key] = identity[key]; });
    linkAccountProfile(identity);
    return payload;
  }

  function forgetPersistentProfile() {
    var profileId = '';
    try {
      var record = JSON.parse(window.localStorage.getItem(PROFILE_KEY) || 'null');
      profileId = record && record.id ? String(record.id) : '';
    } catch (error) {
      profileId = storedId(window.localStorage, PROFILE_KEY);
    }
    if (profileId && loggedInCustomer()) {
      window.fetch(ACCOUNT_PROFILE_URL, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ profileId: profileId })
      }).catch(function () {});
    } else if (profileId) {
      window.fetch(API_URL + '?action=forget', {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ profileId: profileId })
      }).catch(function () {});
    }
    try {
      window.localStorage.removeItem(PROFILE_KEY);
      window.sessionStorage.removeItem(ACCOUNT_LINK_KEY);
    } catch (error) {}
  }

  function enforceConsentState() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var preferencesKnown = privacy &&
      typeof privacy.preferencesProcessingAllowed === 'function';
    var analyticsKnown = privacy &&
      typeof privacy.analyticsProcessingAllowed === 'function';
    if (preferencesKnown && !preferencesAllowed()) forgetPersistentProfile();
    if (analyticsKnown && !analyticsAllowed()) {
      queued = {};
      try {
        window.sessionStorage.removeItem(PENDING_KEY);
        window.sessionStorage.removeItem(SESSION_PROFILE_KEY);
        window.sessionStorage.removeItem(SESSION_KEY);
      } catch (error) {}
    }
  }

  function normaliseQuery(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function contextFromPage() {
    var app = document.getElementById('PrewornWideSearch');
    var mode = app ? String(app.getAttribute('data-mode') || '') : '';
    return {
      type: mode === 'collection' ? 'collection' : 'search',
      handle: mode === 'collection'
        ? String(app.getAttribute('data-collection-handle') || '') : '',
      title: mode === 'collection'
        ? String(app.getAttribute('data-collection-title') || '') : ''
    };
  }

  function sourceFromForm(form) {
    if (!form) return 'search_form';
    if (form.id === 'searchFormHeader') return 'header';
    if (form.closest && form.closest('#PrewornMobileSearchPanel')) return 'mobile_header';
    var context = contextFromPage();
    return context.type === 'collection' ? 'collection_search' : 'search_page';
  }

  function resultSignature(detail) {
    return [
      normaliseQuery(detail.query),
      detail.contextType === 'collection' ? 'collection' : 'search',
      String(detail.contextHandle || '').toLowerCase()
    ].join('|');
  }

  function historyIdentity(signature) {
    try {
      var state = window.history && window.history.state;
      var record = state && state[HISTORY_KEY];
      if (record && record.signature === signature && record.eventId) return record;
    } catch (error) {}
    return null;
  }

  function writeHistoryIdentity(record) {
    try {
      if (!window.history || typeof window.history.replaceState !== 'function') return;
      var state = Object.assign({}, window.history.state || {});
      state[HISTORY_KEY] = record;
      window.history.replaceState(state, '', window.location.href);
    } catch (error) {}
  }

  function pendingIdentity(query) {
    if (!analyticsAllowed()) return null;
    try {
      var stored = window.sessionStorage.getItem(PENDING_KEY);
      if (!stored) return null;
      var record = JSON.parse(stored);
      if (!record || !record.eventId ||
          Date.now() - Number(record.createdAt || 0) > PENDING_MAX_AGE) {
        window.sessionStorage.removeItem(PENDING_KEY);
        return null;
      }
      if (normaliseQuery(record.query) !== normaliseQuery(query)) return null;
      window.sessionStorage.removeItem(PENDING_KEY);
      return record;
    } catch (error) {
      return null;
    }
  }

  function rememberSearchSubmission(form) {
    if (!analyticsAllowed()) return;
    var input = form && form.querySelector && form.querySelector('input[name="q"]');
    var query = input ? String(input.value || '').trim() : '';
    if (!query || query === '*') return;
    var context = contextFromPage();
    var record = {
      eventId: randomId(),
      query: query,
      source: sourceFromForm(form),
      createdAt: Date.now()
    };
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(record));
    } catch (error) {}
    writeHistoryIdentity({
      eventId: record.eventId,
      signature: [normaliseQuery(query), context.type, context.handle.toLowerCase()].join('|'),
      source: record.source
    });
  }

  function post(payload) {
    return window.fetch(API_URL + '?action=record', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Search analytics request failed');
      return response.json();
    });
  }

  function flush() {
    if (!analyticsAllowed() || automatedClient()) return;
    Object.keys(queued).forEach(function (eventId) {
      if (sending[eventId]) return;
      sending[eventId] = true;
      post(attachCurrentIdentity(queued[eventId])).then(function () {
        delete queued[eventId];
      }).catch(function () {
        // Search must never wait for analytics. A later consent, online or
        // visibility event will make one more best-effort attempt.
      }).then(function () {
        delete sending[eventId];
      });
    });
  }

  function recordResult(detail) {
    detail = detail || {};
    var query = String(detail.query || '').trim();
    if (!query || query === '*' || !isFinite(Number(detail.resultCount))) return;

    var signature = resultSignature(detail);
    var pending = pendingIdentity(query);
    var identity = pending || historyIdentity(signature) || {
      eventId: randomId(),
      source: String(detail.source || 'direct')
    };
    identity.signature = signature;
    identity.source = String(identity.source || detail.source || 'direct');
    writeHistoryIdentity(identity);

    queued[identity.eventId] = {
      eventId: identity.eventId,
      query: query,
      contextType: detail.contextType === 'collection' ? 'collection' : 'search',
      contextHandle: String(detail.contextHandle || ''),
      contextTitle: String(detail.contextTitle || ''),
      path: String(detail.path || window.location.pathname || ''),
      source: identity.source,
      resultCount: Math.max(0, Math.round(Number(detail.resultCount))),
      resultCountIsEstimate: !!detail.resultCountIsEstimate,
      catalogSource: String(detail.catalogSource || ''),
      wardrobeActive: !!detail.wardrobeActive,
      routeId: Math.max(0, Math.round(Number(detail.routeId) || 0)),
      routeDestination: String(detail.routeDestination || '')
    };
    flush();
  }

  function initialisePrivacy() {
    enforceConsentState();
    if (analyticsAllowed()) {
      linkAccountProfile(searchIdentity());
      flush();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function () {
        enforceConsentState();
        linkAccountProfile(searchIdentity());
        flush();
      });
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('input[name="q"]')) return;
    rememberSearchSubmission(form);
  }, true);
  document.addEventListener('preworn:search-results', function (event) {
    recordResult(event.detail);
  });
  document.addEventListener('visitorConsentCollected', function () {
    enforceConsentState();
    flush();
  });
  window.addEventListener('preworn:search-profile-cleared', function () {
    // The verified account endpoint has already removed every server-side
    // association. Rotate all browser identifiers before any future search.
    queued = {};
    sending = {};
    try {
      window.localStorage.removeItem(PROFILE_KEY);
      window.sessionStorage.removeItem(SESSION_PROFILE_KEY);
      window.sessionStorage.removeItem(SESSION_KEY);
      window.sessionStorage.removeItem(ACCOUNT_LINK_KEY);
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {}
  });
  window.addEventListener('online', flush);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) flush();
  });

  initialisePrivacy();
})();
